module.exports = __webpack_public_path__ + "static/media/tools-multiple-elective.2f484cd3.svg";